// @ts-nocheck
/**
 * @deprecated
 * Use the "AccountSettingsForm" widget instead.
 */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { hasChanges } from "@insite/client-framework/Store/Pages/AccountSettings/AccountSettingsSelectors";
import saveCurrentAccount from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    account: state.pages.accountSettings.editingAccount,
    isEmailValid: !state.pages.accountSettings.emailErrorMessage,
    hasChanges: hasChanges(state),
    useDefaultCustomer: state.pages.accountSettings.useDefaultCustomer,
    initialUseDefaultCustomer: state.pages.accountSettings.initialUseDefaultCustomer,
});

const mapDispatchToProps = {
    saveCurrentAccount,
    setInitialValues,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface AccountSettingsSubmitStyles {
    saveButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
}

export const accountSettingsStyles: AccountSettingsSubmitStyles = {
    cancelButton: { variant: "secondary" },
};

const styles = accountSettingsStyles;

const AccountSettingsSubmit = ({
    account,
    isEmailValid,
    hasChanges,
    useDefaultCustomer,
    saveCurrentAccount,
    setInitialValues,
}: Props) => {
    const toasterContext = useContext(ToasterContext);

    if (!account) {
        return null;
    }

    const updateSettingsHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        saveCurrentAccount({
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Settings updated"), messageType: "success" });
            },
            onError: message => {
                toasterContext.addToast({ body: message, messageType: "warning" });
            },
        });
    };

    const invalidCustomerState = useDefaultCustomer && !account.defaultCustomerId;
    const enableSaveButton = hasChanges && isEmailValid && !invalidCustomerState;

    return (
        <FormActions>
            <Button
                {...styles.saveButton}
                onClick={updateSettingsHandler}
                disabled={!enableSaveButton}
                data-test-selector="accountSettings_save"
            >
                {translate("Save")}
            </Button>
            <Button {...styles.cancelButton} onClick={setInitialValues} disabled={!hasChanges}>
                {translate("Reset Changes")}
            </Button>
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountSettingsSubmit),
    definition: {
        group: "Account Settings",
        allowedContexts: [],
        displayName: "Submit",
    },
};

export default widgetModule;
